import Immutable from 'immutable';

const fromJSOrdered = (js) => {
  if (typeof js !== 'object' || js === null) {
    return js;
  }

  return Array.isArray(js)
    ? Immutable.Seq(js).map(fromJSOrdered).toList()
    : Immutable.Seq(js).map(fromJSOrdered).toOrderedMap();
};

export default fromJSOrdered;
